export var sizes = {
  S: 'sizeS',
  M: 'sizeM',
  L: 'sizeL',
  XL: 'sizeXL'
};
export var offsets = {
  S: 'offsetS',
  M: 'offsetM',
  L: 'offsetL',
  XL: 'offsetXL'
};